document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product11-sale-timer').forEach(bar => {
    const duration = Number(bar.dataset.duration || 2100);
    const key = 'ms_gummies_sale_timer_end';
    let end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + duration * 1000;
      localStorage.setItem(key, String(end));
    }
    const tick = () => {
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60
      };
      Object.entries(values).forEach(([name, value]) => {
        const field = bar.querySelector(`[data-${name}]`);
        if (field) field.textContent = String(value).padStart(2, '0');
      });
      if (remaining === 0) clearInterval(interval);
    };
    const interval = setInterval(tick, 1000);
    tick();
    bar.querySelector('.product11-sale-timer__close')?.addEventListener('click', () => { bar.style.display = 'none'; });
  });

  const section = document.querySelector('[id^="Product11PackageSelector-"]');
  if (section) {
    const image = section.querySelector('[data-product11-main-image]');
    const row = section.querySelector('[data-product11-gallery-row]');
    if (image && row) {
      const originals = [...row.querySelectorAll('[data-product11-gallery-thumb]')];
      if (originals.length && originals.length < 8) {
        const rounds = originals.length <= 3 ? 3 : 2;
        for (let round = 0; round < rounds; round++) {
          originals.forEach(original => {
            const clone = original.cloneNode(true);
            clone.removeAttribute('id');
            row.appendChild(clone);
          });
        }
      }
      const thumbs = [...row.querySelectorAll('[data-product11-gallery-thumb]')];
      let moving = false;
      let pausedUntil = 0;
      const gap = () => parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || '14') || 14;
      const step = () => (row.querySelector('[data-product11-gallery-thumb]')?.getBoundingClientRect().width || 150) + gap();
      const next = () => {
        if (moving) return;
        moving = true;
        row.classList.add('is-transitioning');
        row.style.transform = `translate3d(-${step()}px, 0, 0)`;
        setTimeout(() => {
          row.classList.remove('is-transitioning');
          row.style.transform = 'translate3d(0, 0, 0)';
          row.appendChild(row.firstElementChild);
          moving = false;
        }, 430);
      };
      const previous = () => {
        if (moving) return;
        moving = true;
        row.classList.remove('is-transitioning');
        row.insertBefore(row.lastElementChild, row.firstElementChild);
        row.style.transform = `translate3d(-${step()}px, 0, 0)`;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          row.classList.add('is-transitioning');
          row.style.transform = 'translate3d(0, 0, 0)';
        }));
        setTimeout(() => { row.classList.remove('is-transitioning'); moving = false; }, 430);
      };
      section.querySelector('[data-product11-gallery-prev]')?.addEventListener('click', () => { pausedUntil = Date.now() + 2200; previous(); });
      section.querySelector('[data-product11-gallery-next]')?.addEventListener('click', () => { pausedUntil = Date.now() + 2200; next(); });
      row.addEventListener('mouseenter', () => { pausedUntil = Infinity; });
      row.addEventListener('mouseleave', () => { pausedUntil = Date.now() + 2200; });
      setInterval(() => { if (Date.now() >= pausedUntil) next(); }, 2400);
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        const source = thumb.dataset.fullImage;
        if (!source) return;
        pausedUntil = Date.now() + 2200;
        image.src = source;
        image.alt = thumb.dataset.fullAlt || image.alt;
        if (thumb.dataset.fullWidth) image.width = Number(thumb.dataset.fullWidth);
        if (thumb.dataset.fullHeight) image.height = Number(thumb.dataset.fullHeight);
        thumbs.forEach(item => item.classList.toggle('is-active', item.dataset.fullImage === source));
      }));
    }
  }

  const carousel = document.querySelector('#carousel');
  if (carousel) {
    [...carousel.children].forEach(card => carousel.appendChild(card.cloneNode(true)));
    document.querySelector('.next')?.addEventListener('click', () => carousel.scrollBy({ left: 320, behavior: 'smooth' }));
    document.querySelector('.prev')?.addEventListener('click', () => carousel.scrollBy({ left: -320, behavior: 'smooth' }));
    carousel.addEventListener('scroll', () => {
      if (carousel.scrollLeft >= carousel.scrollWidth / 2) carousel.scrollLeft = 0;
    });
  }

  document.querySelectorAll('[data-results-track]').forEach(track => {
    const section = track.closest('section') || track.parentElement;
    const card = track.querySelector('.p11-results__card');
    const amount = () => (card?.offsetWidth || 396) + (parseFloat(getComputedStyle(track).gap) || 24);
    const nudge = direction => {
      track.style.animationPlayState = 'paused';
      track.style.transition = 'transform .45s ease';
      track.style.transform = `translate3d(${direction * amount()}px, 0, 0)`;
      setTimeout(() => {
        track.style.transition = '';
        track.style.transform = '';
        track.style.animationPlayState = 'running';
      }, 480);
    };
    section.querySelector('.p11-results__arrow--prev')?.addEventListener('click', () => nudge(1));
    section.querySelector('.p11-results__arrow--next')?.addEventListener('click', () => nudge(-1));
  });
});
